import type { CaseResult } from './types';

export function countFeasibleCases(cases: CaseResult[], timeS: number): number {
  return cases.filter((item) => {
    const checkpoint = item.checkpoints.find((point) => point.time_s === timeS);
    return (checkpoint?.current.feasible ?? 0) > 0;
  }).length;
}
